import React, { Component } from 'react'
import { Field } from 'redux-form'
import { renderTextField } from '../../../Forms/fieldRenderers'
import { required, getNumericValidator } from '../../../Forms/fieldValidators'
import moment from 'moment'
import { Row, Col } from 'react-bootstrap'
import CupoInfo from '../CupoInfo'

const numeric0to100 = getNumericValidator(0, 100)

export class EditAsignacionDialogView extends Component {
  render () {
    const { currentCupo } = this.props
    moment.locale('ar-AR')
    const fecha = moment(currentCupo.fechaDeEmision).format('L')

    currentCupo.fecha = fecha

    const fields = ['exportador', 'cereal', 'fecha']

    return (
      <Row>
        <Col md={6} className='modificacion-dialog'>
          <Field
            name='cantidad'
            label='Cantidad asignada'
            type='number'
            component={renderTextField}
            validate={[required, numeric0to100]}
            placeholder=''
          />
        </Col>

        <Col md={6} style={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center' }}>
          <CupoInfo cupo={currentCupo} fields={fields} />
        </Col>

      </Row>
    )
  }
}
